<template>
  <button class="bg-cal-81B920 hover:bg-cal-green text-white uppercase px-4 py-3 text-sm" type="submit"><slot></slot></button>
</template>
<script>
export default {
  name: 'PrimaryButton',
}
</script>
